import { memo, useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import ProgressPromise from 'atpjs/xhr_fetch/progress_promise'

const Progress = memo(({ promise }) => {
  const [progress, setProgress] = useState(0)
  useEffect(() => {
    promise.onProgress((event) => {
      setProgress(Math.round((100 / event.total) * event.loaded))
    })
  }, [])
  return `${progress}%`
})
Progress.displayName = 'DocumentListProgress'
Progress.propTypes = {
  promise: PropTypes.instanceOf(ProgressPromise).isRequired
}

export default Progress
